import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import urllink from '../life-config/apiEndPoints.json';
@Injectable()
export class AuthService {

    // Behaviour subject remembers last value
    // private pathParamState = new BehaviorSubject<string>();
    public loggedIn = new BehaviorSubject<boolean>(false);
    amsURlInfo: any = urllink['apiEndPoints']['amsURL'];
    private user: {};

    private BASE_URL = '/api/v1/accounts';
    private headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    // public is_logged_in: Observable<boolean>;

    constructor(private router: Router) {
        this.logOut = this.logOut.bind(this);
    }

    get isLoggedIn() {
        return this.loggedIn.asObservable();
    }

    setUser = (user) => {

        if (user && user.token) {
            localStorage.setItem('ta_token', user.token);
            this.loggedIn.next(true);

        } else {
            this.logOut();
        }
    }



    logOut() {
        localStorage.removeItem('ta_token');

        this.loggedIn.next(false);
        window.location.href = this.amsURlInfo['amsURL'] + '?next=' + this.amsURlInfo['baseUrl'] + this.router.routerState.snapshot.url;
    }


    GetUserToken() {
        const token = localStorage.getItem('ta_token');
        if (token && (token !== 'undefined') && (token !== 'null')) {
            return token;
        } else {
            return false;
        }
    }



}
